import { Rpc } from "rpc/rpc";
import { ValueWrapper } from "rpc/ValueWrapper";


export class ExtraWorkDaysRpc {

    public static list(): Promise<ListResp> {
        return Rpc.GET("/rpc/settings/extraworkdays/list");
    }

    public static add(req: AddExtraWorkDayReq): Promise<ValueWrapper<number>> {
        return Rpc.POST("/rpc/settings/extraworkdays/add", req);
    }

    public static delete(id: number): Promise<ValueWrapper<number>> {
        return Rpc.POST("/rpc/settings/extraworkdays/delete", {value: id});
    }

    private constructor() {}

}



export interface ListResp {

    items: ExtraWorkDayRespItem[];

}

export interface ExtraWorkDayRespItem {

    id: number;
    date: string;
    desc: string;
    holiday: boolean;

}

export interface AddExtraWorkDayReq {
    date: string;
    desc: string;
    holiday: boolean;
}